import React from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { IconEdit } from '../../../../../../shared/icon/icon'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { Card } from '../../../../../../shared/card/card'
import { FolderMenu } from '../../common/menu/node-actions'
import { Route, useRouteMatch } from '../../../../../../../node_modules/react-router-dom/cjs/react-router-dom.min'
import { AssetList } from '../../common/assets/asset-list'
import { FormSimple } from '../../../../../../shared/form-simple/form'
import { FormSimpleText } from '../../../../../../shared/form-simple/form-text'
import { FormSimpleJsonEditor } from '../../../../../../shared/form-simple/form-json-editor'
import { FormSimpleSubmitEdit } from '../../../../../../shared/form-simple/form-submit'

export const NodeCategoryEditSys = ({ parentURL, nodeID, useApiForm, dataContext, section }) => {
  const { url } = useRouteMatch()

  const apiForm = useApiForm()

  const handleMatch = () => apiForm.get(nodeID)

  const handleSubmit = async data => {
    await apiForm.put(data.id, data)
    await dataContext.reload()
  }

  const HeaderMenu = () => <FolderMenu place="header" url={parentURL} nodeID={nodeID} section={section} />

  return (
    <React.Fragment>
      <BreadcrumbView text="sys edit" Icon={IconEdit} onMatch={handleMatch}>
        <CardFullHeightScrollY title="sys edit" HeaderMenu={HeaderMenu}>
          <Card>
            <FormSimple state={apiForm.form} onRefresh={handleMatch} onSubmit={handleSubmit}>
              <FormSimpleText name="name" />
              <FormSimpleJsonEditor name="metadata" />
              <FormSimpleSubmitEdit backURL={parentURL} />
            </FormSimple>
          </Card>
        </CardFullHeightScrollY>
      </BreadcrumbView>

      <Route path={`${url}/assets`}>
        <AssetList parentURL={url} nodeID={nodeID} />
      </Route>
    </React.Fragment>
  )
}
